/**
 * Card Cart Button Component
 * Handles AJAX add to cart functionality for product cards
 */

class CardCartButton extends HTMLElement {
  constructor() {
    super();
    
    this.button = this.querySelector('button');
    this.variantId = this.dataset.variantId;
    this.productTitle = this.dataset.productTitle || 'Product';
    
    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
  }
  
  async handleClick(e) {
    e.preventDefault();
    e.stopPropagation(); // Prevent card link click
    
    // Disable button during request
    this.button.disabled = true;
    this.button.classList.add('loading');
    
    try {
      // Add to cart via Shopify AJAX API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1
        })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add to cart');
      }
      
      const data = await response.json();
      
      // Get updated cart
      const cart = await this.getCart();
      
      // Dispatch event for cart drawer/count update
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { 
          item: data,
          cart: cart
        } 
      }));
      
      
    } catch (error) {
      console.error('Add to cart error:', error);
      this.showError(error.message);
    } finally {
      this.button.disabled = false;
      this.button.classList.remove('loading');
    }
  }
  
  async getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('Get cart error:', error);
      return null;
    }
  }
  
  showError(message) {
    this.button.classList.add('error');
    
    // Log error
    console.error('Cart error:', message);
    
    // Optional: Show error notification
    // You can integrate with your notification system here
    
    // Remove error state after 2 seconds
    setTimeout(() => {
      this.button.classList.remove('error');
    }, 2000);
  }
}

// Register custom element
customElements.define('card-cart-button', CardCartButton);
